import { apiRequest, meetingRegistrationDetail } from "../../../../services/adapters/base";

class DetailRepository {
	fetchDetail = async (query) => {
		return await apiRequest(
			"get",
			meetingRegistrationDetail,
			{
				params: query,
			},
			true
		);
	};
}

export default DetailRepository;
